import { render, staticRenderFns } from "./AddRuleModal.vue?vue&type=template&id=3a72db3e&scoped=true"
import script from "./AddRuleModal.vue?vue&type=script&lang=js"
export * from "./AddRuleModal.vue?vue&type=script&lang=js"
import style0 from "./AddRuleModal.vue?vue&type=style&index=0&id=3a72db3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a72db3e",
  null
  
)

export default component.exports